import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { GET_ROLE_MENU, GET_USERS } from 'const';
import { Menu, User } from 'types';

export const fetchMenus = (_: any, config?: AxiosRequestConfig<Menu[]>) => {
  return axios.get<Menu[]>(GET_ROLE_MENU, config);
};

export const fetchUsers = async (
  _: any,
  config?: AxiosRequestConfig<User[]>,
): Promise<AxiosResponse<User[]>> => {
  const data = await axios.get<{ result: User[] }>(GET_USERS, config);
  return {
    ...data,
    data: data.data.result, // Ajustas el tipo para que sea User[]
  };
};
